import { Outlet, Navigate } from 'react-router-dom';
import { getSessionUser } from '../../utils/users';

export const NoTouchRouter = () => {
	const IsNoTouch = () => {
		return getSessionUser()?.perfil === 'Agencia-brt' ? true : false;
		// Opcionalmente adicionar outros perfis com acesso a plataforma No Touch
	};
	return IsNoTouch() ? <Outlet /> : <Navigate to='/historico' />;
};
